import {
  GET_PROFORMA_INVOICE_LIST_PROGRESS,
  GET_PROFORMA_INVOICE_LIST_SUCCESS,
  GET_PROFORMA_INVOICE_LIST_FAILURE,
  ADD_PROFORMA_INVOICE_PROGRESS,
  ADD_PROFORMA_INVOICE_SUCCESS,
  ADD_PROFORMA_INVOICE_FAILURE,
  EDIT_DELETE_PROFORMA_INVOICE_PROGRESS,
  EDIT_DELETE_PROFORMA_INVOICE_SUCCESS,
  EDIT_DELETE_PROFORMA_INVOICE_FAILURE,
  RESET_MESSAGE,
  GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS,
  GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE,
  GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
} from "../../types/actionTypes";

const initialState = {
  ProformaInvoice: [],
  lastEntryNo: null,
  proforma_itemDescription_forManualEntry: [],
  loginUser: null,
  error: false,
  loading: false,
  message: null,
};

const proforma_invoice_reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFORMA_INVOICE_LIST_SUCCESS:
     
      return { ...state, ProformaInvoice: action.ProformaInvoice, lastEntryNo: action.ProformaInvoice[0].invoiceNo, loading: false };
    case GET_PROFORMA_INVOICE_LIST_FAILURE:
      return { ...state, loading: false, error: true };
    case GET_PROFORMA_INVOICE_LIST_PROGRESS:
      return { ...state, loading: true, error: false };
    case ADD_PROFORMA_INVOICE_PROGRESS:
      return { ...state, loading: true };
    case ADD_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        ProformaInvoice: [...state.ProformaInvoice, action.payload],
        loading: false,
        error: false,
        message: action.payload.message,
      };
    case ADD_PROFORMA_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.payload.message,
      };
    case EDIT_DELETE_PROFORMA_INVOICE_PROGRESS:
      return { ...state, loading: true };
    case EDIT_DELETE_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        ProformaInvoice: state.ProformaInvoice.map((ProformaInvoice) =>
          ProformaInvoice._id === action.payload._id
            ? action.payload
            : ProformaInvoice
        ),
        message: action.payload.message,
      };
    case EDIT_DELETE_PROFORMA_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.payload.message,
      };

    case GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS:
      return {
        ...state,
        sales_itemDescription_forManualEntry:
          action.proforma_itemDescription_forManualEntry,
        loading: false,
      };
    case GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE:
      return { ...state, loading: false, error: true };
    case GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS:
      return { ...state, loading: true, error: false };

    case RESET_MESSAGE:
      return { ...state, message: null }; // Reset the edit message

    default:
      return state;
  }
};

export default proforma_invoice_reducer;
